import { 
  collection, 
  addDoc, 
  updateDoc, 
  deleteDoc, 
  doc, 
  query, 
  where, 
  getDocs,
  arrayUnion,
  Timestamp
} from 'firebase/firestore';
import { db } from './config';
import { Product } from '../../types/Product';
import type { ShoppingList } from '../../types/ShoppingList';

export const getUserShoppingLists = async (userId: string): Promise<ShoppingList[]> => {
  try {
    const q = query(
      collection(db, 'shoppingLists'),
      where('userId', '==', userId)
    );
    
    const snapshot = await getDocs(q);
    return snapshot.docs.map(doc => ({
      id: doc.id,
      ...doc.data()
    })) as ShoppingList[];
  } catch (error) {
    console.error('Error fetching shopping lists:', error);
    return [];
  }
};

export const createShoppingList = async (list: Omit<ShoppingList, 'id'>) => {
  try {
    const docRef = await addDoc(collection(db, 'shoppingLists'), {
      ...list,
      createdAt: Timestamp.now()
    });
    return { success: true, id: docRef.id };
  } catch (error) {
    console.error('Error creating list:', error);
    return { success: false, error };
  }
};

export const updateShoppingList = async (listId: string, updates: Partial<ShoppingList>) => {
  try {
    await updateDoc(doc(db, 'shoppingLists', listId), updates);
    return { success: true };
  } catch (error) {
    console.error('Error updating list:', error);
    return { success: false, error };
  }
};

export const deleteShoppingList = async (listId: string) => {
  try {
    await deleteDoc(doc(db, 'shoppingLists', listId));
    return { success: true };
  } catch (error) {
    console.error('Error deleting list:', error);
    return { success: false, error };
  }
};

export const addProductToList = async (userId: string, product: Product) => {
  try {
    const q = query(
      collection(db, 'shoppingLists'),
      where('userId', '==', userId),
      where('active', '==', true)
    );
    
    const snapshot = await getDocs(q);
    
    if (snapshot.empty) {
      await addDoc(collection(db, 'shoppingLists'), {
        userId,
        name: 'Mi lista de compra',
        products: [product],
        active: true,
        createdAt: Timestamp.now()
      });
    } else {
      const listDoc = snapshot.docs[0];
      await updateDoc(doc(db, 'shoppingLists', listDoc.id), {
        products: arrayUnion(product)
      });
    }
    
    return { success: true };
  } catch (error) {
    console.error('Error adding product to list:', error);
    return { success: false, error };
  }
};